import { PAGE_HEIGHT_IS_TOO_LONG } from '../../../constants/rulesConstants';
import GemMeterBaseRule from '../GemMeterBaseRule';

export default class PageHightIsTooLongRule {
  static ruleId = PAGE_HEIGHT_IS_TOO_LONG.id;

  static validate() {
    const iframe = GemMeterBaseRule.getIframeDocument();
    if (iframe?.body && iframe.body.offsetHeight) {
      return iframe?.body.offsetHeight > 0
        ? (iframe?.body.offsetHeight - 350) < 3000
        : false
    }

    return false;
  }
}
